import LeftToRight from './LeftToRight';

export default LeftToRight;
